import React from 'react'
import classNames from 'classnames'

import { type ITextInputProps } from './types'

export const TextInput = React.forwardRef<HTMLInputElement, ITextInputProps>(
  (
    {
      error,
      name,
      required,
      label,
      labelClassName,
      className = '',
      children,
      ...rest
    },
    ref,
  ) => {
    return (
      <div
        className={classNames('', className, {
          error: !!error,
        })}
      >
        {!!label && (
          <label htmlFor={name} className={classNames('', labelClassName)}>
            {label}
            {required && <sup> *</sup>}
          </label>
        )}
        <input ref={ref} type="text" id={name} name={name} {...rest} />
        {children}
      </div>
    )
  },
)

TextInput.displayName = 'TextInput'
